module.exports = __webpack_public_path__ + "img/hatch.4a191253.png";